import iltIcon from './assets/ilteducation.svg';
import inlastaIcon from './assets/productIcons/inlasta.svg';
import polylinoSchoolIcon from './assets/productIcons/polylino-school.svg';
import polylinoPreschoolIcon from './assets/productIcons/polylino-preschool.svg';
import begreppaIcon from './assets/productIcons/begreppa.svg';
import manabuaIcon from './assets/productIcons/manabua.svg';
import lukulumoPreschoolIcon from './assets/productIcons/lukulumo-preschool.svg';
import lukulumoSchoolIcon from './assets/productIcons/lukulumo-school.svg';
import sondoIcon from './assets/productIcons/sondo.svg';

export type AppNames =
  | 'ilteducation'
  | 'inlasta'
  | 'polylinoSchool'
  | 'polylinoPreschool'
  | 'begreppa'
  | 'manabua'
  | 'lukulumoPreschool'
  | 'lukulumoSchool'
  | 'sondo';

export const appToLogo: Record<AppNames, string> = {
  ilteducation: iltIcon,
  inlasta: inlastaIcon,
  polylinoSchool: polylinoSchoolIcon,
  polylinoPreschool: polylinoPreschoolIcon,
  begreppa: begreppaIcon,
  manabua: manabuaIcon,
  lukulumoPreschool: lukulumoPreschoolIcon,
  lukulumoSchool: lukulumoSchoolIcon,
  sondo: sondoIcon,
};

export { iltIcon };

// polylino is branded per market: fi -> lukulumo, fr -> sondo, others -> polylino.
const polylinoIconByRealm: Record<string, string> = {
  se: polylinoSchoolIcon,
  de: polylinoSchoolIcon,
  no: polylinoSchoolIcon,
  fi: lukulumoSchoolIcon,
  fr: sondoIcon,
};

export const getPolylinoIcon = (realm: string): string => polylinoIconByRealm[realm] ?? polylinoSchoolIcon;

export const audioAidIcon = inlastaIcon;
